import React from 'react';
import styles from './styles.module.css';

export default function SkeletonLoader({ count = 3 }) {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className={styles.SkeletonCard}>
          <div className={styles.SkeletonTitle} />
          <div className={styles.SkeletonText} />
        </div>
      ))}
    </>
  );
}